import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useSelector, useDispatch } from "react-redux";

function OrderFail() {
    const [cart, setCart] = useState([]);
    const [errors, setErrors] = useState(false);
    let cartRaw = useSelector((state) => state.data?.cart);
    useEffect(() => {
        let parsedCart = [];
        if (typeof cartRaw === "string") {
            try {
                parsedCart = JSON.parse(cartRaw);
            } catch (e) {
                console.error("Invalid JSON in cartRaw:", cartRaw);
            }
        }
        setCart(parsedCart);
    }, [cartRaw]);
    return (
        <>
            <div class="successCard">
                <div class="checkmark">
                    <svg viewBox="0 0 52 52">
                        <circle cx="26" cy="26" r="25" fill="none" stroke="#FF4C4C" />
                        <path d="M16 16l20 20M36 16L16 36" stroke="#FF4C4C" />
                    </svg>
                </div>
                <h1>Order Failed</h1>
                <p>There was a problem placing your order. Please try again or contact support.</p>
                <a href="/bazaar" class="btn">Return to Homepage</a>
            </div>
        </>
    );
}

export default OrderFail;
